import config from '../config';

const fabricService = {
  async getAllFabrics() {
    try {
      const response = await fetch(`${config.API_URL}/fabrics`);
      const data = await response.json();
      return data.fabrics || [];
    } catch (error) {
      console.error('Error fetching fabrics:', error);
      throw error;
    }
  },

  async getFabricById(id) {
    try {
      const response = await fetch(`${config.API_URL}/fabrics/${id}`);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching fabric:', error);
      throw error;
    }
  },

  async createFabric(fabricData) {
    try {
      const formData = new FormData();
      formData.append('name', fabricData.name);
      formData.append('description', fabricData.description);
      if (fabricData.main_image) {
        formData.append('main_image', fabricData.main_image);
      }

      const response = await fetch(`${config.API_URL}/fabrics`, {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error('Failed to create fabric');
      }

      return await response.json();
    } catch (error) {
      console.error('Error creating fabric:', error);
      throw error;
    }
  },

  async updateFabric(id, fabricData) {
    try {
      const formData = new FormData();
      formData.append('name', fabricData.name);
      formData.append('description', fabricData.description);
      if (fabricData.main_image) {
        formData.append('main_image', fabricData.main_image);
      }

      const response = await fetch(`${config.API_URL}/fabrics/${id}`, {
        method: 'PUT',
        body: formData
      });

      if (!response.ok) {
        throw new Error('Failed to update fabric');
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating fabric:', error);
      throw error;
    }
  },

  async deleteFabric(id) {
    try {
      const response = await fetch(`${config.API_URL}/fabrics/${id}`, {
        method: 'DELETE'
      });

      if (!response.ok) {
        throw new Error('Failed to delete fabric');
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting fabric:', error);
      throw error;
    }
  },

  async addFabricPhoto(fabricId, imageFile) {
    try {
      const formData = new FormData();
      formData.append('image', imageFile);

      const response = await fetch(`${config.API_URL}/fabrics/${fabricId}/photos`, {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error('Failed to add photo');
      }

      return await response.json();
    } catch (error) {
      console.error('Error adding fabric photo:', error);
      throw error;
    }
  },

  async getFabricPhotos(fabricId) {
    try {
      const response = await fetch(`${config.API_URL}/fabrics/${fabricId}/photos`);
      const data = await response.json();
      return data.photos || [];
    } catch (error) {
      console.error('Error fetching fabric photos:', error);
      throw error;
    }
  },

  async deleteFabricPhoto(photoId) {
    try {
      const response = await fetch(`${config.API_URL}/fabrics/photos/${photoId}`, {
        method: 'DELETE'
      });

      if (!response.ok) {
        throw new Error('Failed to delete photo');
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting fabric photo:', error);
      throw error;
    }
  }
};

export default fabricService; 